import { NativeDateAdapter } from '@angular/material';
import { Injectable } from '@angular/core';

@Injectable()
export class MondayFirstDateAdapter extends NativeDateAdapter {
  getFirstDayOfWeek(): number {
    return 1;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/misc/monday-first-date-adapter.ts